import { useRef, useState } from "react";
import { toast } from "sonner";
import { Camera, Loader2 } from "lucide-react";
import { uploadFile, errMsg, fileUrl } from "@/lib/api";

export default function ImageUpload({ value, onChange, kind = "general", label = "Unggah Foto", testid = "image-upload", className = "h-32" }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    try {
      onChange(await uploadFile(f, kind));
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };
  return (
    <button type="button" data-testid={testid} onClick={() => ref.current?.click()}
      className={`relative w-full ${className} rounded-2xl border-2 border-dashed border-slate-300 bg-white overflow-hidden grid place-items-center hover:border-emerald-400 transition-colors`}>
      {value ? <img src={fileUrl(value)} alt={label} className="absolute inset-0 w-full h-full object-cover" /> : (
        <span className="flex flex-col items-center gap-1 text-slate-500 text-xs font-semibold">
          <Camera className="w-6 h-6" /> {label}
        </span>
      )}
      {busy && <span className="absolute inset-0 bg-white/70 grid place-items-center"><Loader2 className="w-6 h-6 animate-spin" /></span>}
      <input ref={ref} type="file" accept="image/*" hidden onChange={pick} />
    </button>
  );
}
